import { Stack, Typography } from "@mui/material"

export const Welcome = () => {
    return (
        <Stack width='100%' alignItems='center' height='70vh' justifyContent='center' gap={5}>
            <Typography variant="h3" color="initial"> Bienvenidos a ANIBER</Typography>
            <img src='/aniber-andamios.jpg' alt='Logo Sigia Aníber' className='logo_welcome'></img>
        </Stack>
    )
}
